const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      requireAuth: false,
      hideBreadcrumb: true,
    },
    component: () => import("@/views/Dashboard.vue"),
  },
];

export default routes;
